import { useState, useEffect } from 'react';
import { webSocketService } from '../services/websocket';
const getCachedEventData = (room, eventName) => {
    const item = localStorage.getItem(`ws-room-${room}-event-${eventName}`);
    if (item) {
        try {
            return JSON.parse(item);
        }
        catch (error) {
            console.error(`Failed to parse cached data for ${room}/${eventName}:`, error);
            localStorage.removeItem(`ws-room-${room}-event-${eventName}`);
            return null;
        }
    }
    return null;
};
const setCachedEventData = (room, eventName, data) => {
    try {
        const jsonData = JSON.stringify(data);
        localStorage.setItem(`ws-room-${room}-event-${eventName}`, jsonData);
    }
    catch (error) {
        console.error(`Failed to cache data for ${room}/${eventName}:`, error);
    }
};
export const useEventSubscription = (room, eventName) => {
    const [data, setData] = useState(() => getCachedEventData(room, eventName));
    const [isLoading, setIsLoading] = useState(!data);
    useEffect(() => {
        const cachedMessage = webSocketService.getCachedData(room);
        if ((cachedMessage === null || cachedMessage === void 0 ? void 0 : cachedMessage.message.event) === eventName) {
            const freshData = cachedMessage.message.data;
            setData((currentData) => {
                if (JSON.stringify(freshData) !== JSON.stringify(currentData)) {
                    setCachedEventData(room, eventName, freshData);
                    return freshData;
                }
                return currentData;
            });
            setIsLoading(false);
        }
        const callback = (message) => {
            if (message.event === eventName) {
                const eventData = message.data;
                setData(eventData);
                setCachedEventData(room, eventName, eventData);
                setIsLoading(false);
            }
        };
        webSocketService.subscribeMessage(room, callback);
        return () => {
            webSocketService.unsubscribeMessage(room, callback);
        };
    }, [room, eventName]);
    useEffect(() => {
        const unsubscribe = webSocketService.onConnectionStatusChange(() => {
            const connectionStatus = webSocketService.getConnectionStatus();
            // Only show loading indicator on reconnect IF there is no data to display.
            if (connectionStatus === 'connecting' && !data) {
                setIsLoading(true);
            }
        });
        return unsubscribe;
    }, [data]);
    return { data, isLoading };
};
